const cards = [
  {
    id: 1,
    title: '国产古装剧专区 · 经典与新作齐飞',
    desc: '从《琅琊榜》到《庆余年》，从《知否》到《梦华录》，收录国产古装剧全集，服化道精良，剧情引人入胜。',
    tag: '古装传奇',
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20architecture%20with%20flowing%20silk%20curtains%2C%20warm%20golden%20lighting%2C%20historical%20drama%20aesthetic%2C%20elegant%20traditional%20Chinese%20elements%2C%20soft%20atmospheric%20haze%2C%20artistic%20illustration%2C%20terracotta%20and%20cream%20tones&width=600&height=400&seq=card-01&orientation=landscape',
  },
  {
    id: 2,
    title: '韩剧精选合集 · 浪漫与悬疑并重',
    desc: '热门韩剧一网打尽，从甜宠爱情到烧脑悬疑，韩语中字高清全集在线看，每周更新最新热门韩剧。',
    tag: '韩剧热播',
    img: 'https://readdy.ai/api/search-image?query=Romantic%20Korean%20drama%20scene%20with%20cherry%20blossoms%20and%20warm%20sunset%20light%2C%20soft%20cinematic%20aesthetic%2C%20pastel%20warm%20tones%2C%20artistic%20illustration%20style%2C%20emotional%20atmosphere%2C%20simple%20composition&width=600&height=400&seq=card-02&orientation=landscape',
  },
  {
    id: 3,
    title: '悬疑探案剧场 · 烧脑高能不断',
    desc: '《白夜追凶》《隐秘的角落》《沉默的真相》等高分悬疑剧全集，剧情紧凑环环相扣，一口气看完停不下来。',
    tag: '悬疑剧场',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20urban%20alleyway%20at%20night%20with%20dramatic%20shadows%20and%20warm%20streetlamp%20light%2C%20crime%20thriller%20atmosphere%2C%20high%20contrast%20cinematic%20look%2C%20artistic%20illustration%2C%20amber%20and%20deep%20shadow%20tones&width=600&height=400&seq=card-03&orientation=landscape',
  },
  {
    id: 4,
    title: '都市情感剧场 · 直击心灵的故事',
    desc: '《三十而已》《都挺好》《欢乐颂》等现实题材好剧，聚焦当代都市生活，笑中带泪，引发共鸣。',
    tag: '都市情感',
    img: 'https://readdy.ai/api/search-image?query=Modern%20city%20skyline%20at%20sunset%20with%20warm%20golden%20light%20through%20glass%20windows%2C%20urban%20life%20aesthetic%2C%20soft%20cinematic%20mood%2C%20artistic%20illustration%20style%2C%20warm%20amber%20and%20rose%20tones&width=600&height=400&seq=card-04&orientation=landscape',
  },
  {
    id: 5,
    title: '美剧英剧专区 · 高分口碑佳作',
    desc: '精选 IMDb 高分美剧英剧全集，从《权力的游戏》到《切尔诺贝利》，原声中字高清画质畅享。',
    tag: '海外剧场',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20cinematic%20landscape%20with%20epic%20scale%20and%20warm%20atmospheric%20lighting%2C%20western%20drama%20aesthetic%2C%20golden%20hour%20mood%2C%20artistic%20illustration%20style%2C%20terracotta%20and%20warm%20beige%20tones&width=600&height=400&seq=card-05&orientation=landscape',
  },
];

export default function SectionCards() {
  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-6 bg-background-100" style={{ scrollMarginTop: '64px' }}>
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
            热门专题
          </span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">热门专题 · 分类追剧更高效</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">按题材分类浏览，快速找到你想看的电视剧</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {cards.slice(0, 3).map((card) => (
            <article key={card.id} className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer">
              <div className="relative h-48 overflow-hidden">
                <img src={card.img} alt={card.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" />
                <span className="absolute top-3 left-3 px-2 py-1 rounded-md bg-primary-500 text-background-50 text-xs font-medium">{card.tag}</span>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-sm md:text-base text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors">{card.title}</h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{card.desc}</p>
              </div>
            </article>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-6">
          {cards.slice(3, 5).map((card) => (
            <article key={card.id} className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer flex flex-col sm:flex-row">
              <div className="relative sm:w-48 h-40 sm:h-auto overflow-hidden flex-shrink-0">
                <img src={card.img} alt={card.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" />
                <span className="absolute top-3 left-3 px-2 py-1 rounded-md bg-primary-500 text-background-50 text-xs font-medium">{card.tag}</span>
              </div>
              <div className="p-5 flex-1 flex flex-col justify-center">
                <h3 className="font-heading text-sm md:text-base text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors">{card.title}</h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{card.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}